'use client';

import React from 'react';
import { Product } from '../types/type';
import ProductCard from '@/features/product-card/components/productCard';
import NumberedPagination from '@/features/pagination/NumberedPagination';
import ProductGridSkeleton from '@/style/scss/layout/product-grid-skeleton/ProductGridSkeleton';

const FlashSaleProduct = ({ flashSales, loading }: any) => {
  return (
    <section className="product padding-top padding-bottom ">
      <div className="container">
        <div className="product__wrapper">
          {loading ? (
            <ProductGridSkeleton />
          ) : (
            <div className="row row-cols-xl-5 row-cols-lg-4 row-cols-md-3 row-cols-2 justify-content-center g-3">
              {flashSales?.data?.length > 0 ? (
                flashSales?.data?.map((data: Product, i: number) => (
                  <ProductCard data={data} key={i} />
                ))
              ) : (
                <p className="text-center">No products available.</p>
              )}
            </div>
          )}
          <div className="product-btn text-center mt-5">
            <NumberedPagination meta={flashSales?.meta || {}} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default FlashSaleProduct;
